<script>
import { mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import { getMyOfficials } from '../api/lobbying';

export default {
  name: 'CpMyRepresentatives',
  components: {
    CpButton: require('../button').default,
    VueSimpleSpinner: require('../vue-simple-spinner').default,
    CpMemberComponent: require('../components/MemberComponent').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  mounted() {
    this.checkAndFetchRepresentatives();
  },
  watch: {
    isAddressCompleted() {
      this.checkAndFetchRepresentatives();
    },
  },
  data() {
    return {
      representatives: [],
      loading: false,
    };
  },
  computed: {
    isAddressCompleted() {
      return this.userProfileData?.address_state && this.userProfileData?.address_zip;
    },
    ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
  },
  methods: {
    checkAndFetchRepresentatives(val) {
      if (this.userProfileData?.address_state && this.userProfileData?.address_zip) {
        this.handleMyRepresentatives();
      }
    },
    async handleMyRepresentatives() {
      this.loading = true;
      try {
        const response = await getMyOfficials();
        this.representatives = response.officials;
      } catch (error) {
        console.error('Error fetching my representatives:', error);
      } finally {
        this.loading = false;
      }
    },
    redirectTo(path) {
      window.location.href = path;
    },
  },
};
</script>

<template>
  <div class="myRepContainer">
    <h4 class="myRepresentativesTitle">
      <i class="fal fa-users-class neutral6-color"></i>
      <span class="buttons neutral6-color" v-margin-left="0.5">{{ $root.isSmallDesktop ? 'My Rep...' : 'My Representatives' }}</span>
    </h4>
    <div v-if="!isUserLogin">
      <cp-button thin noborder @click="redirectTo('/user/login')">Enter your address to see your Representatives</cp-button>
    </div>
    <div v-else-if="!userProfileData?.address_state || !userProfileData?.address_zip">
      <cp-button thin noborder @click="redirectTo('/user/settings')">Enter your address to see your Representatives</cp-button>
    </div>
    <div v-else v-margin-right="$root.isSmallDesktop ? 0 : 1" v-margin-left="$root.isSmallDesktop ? 0 : 1">
      <div v-if="loading" class="spinner">
        <vue-simple-spinner />
      </div>
      <div v-else v-for="rep in representatives" :key="rep.id" v-margin="0.5">
        <CpMemberComponent :image="rep.large_img" :fullname="rep.name" :description="rep.office_name" :permalink="rep.permalink" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.myRepContainer {
  padding-left: 5px;
}
.myRepresentativesTitle,
.spinner {
  display: flex;
  align-items: center;
}
.myRepresentativesTitle span {
  font-family: var(--sans-font);
  font-size: 17px;
  font-weight: bold;
}
.spinner {
  justify-content: center;
}
</style>
